import { Component, ViewEncapsulation, Input, ViewChild, Optional } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { Subscription } from 'rxjs';

@Component({
  selector: 'sg-auto-complete-input',
  templateUrl: './auto-complete-input.component.html',
  styleUrls: ['./auto-complete-input.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class SgAutoCompleteInputComponent {
  @Input() control: FormControl;
  @Input() placeholder: string;

  @ViewChild(MatInput, { static: true }) input: MatInput;

  private _subs: Subscription;

  constructor(@Optional() matSelect: MatSelect) {
    if (matSelect) {
      this._subs = matSelect.openedChange.subscribe((opened) => {
        this.control.setValue('', { emitEvent: false });
        if (opened) {
          setTimeout(() => this.input.focus(), 100);
        }
      });
    }
  }

  ngOnDestroy(): void {
    if (this._subs) {
      this._subs.unsubscribe();
    }
  }

  _onInput(value: string): void {
    if (this.control) {
      this.control.setValue(value);
    }
  }
}
